import { gql } from '@apollo/client';

export const LIST_SPLIT_ROUTE_CACHE = gql`
    query ListSplitRouteCache($warehouseId: Long!, $areaId: Long) {
        listSplitRouteCache(warehouseId: $warehouseId, areaId: $areaId) {
            areaId
            areaName
            data
            savedAt
        }
    }
`;

export const BATCH_DELETE_SPLIT_ROUTE_CACHE = gql`
    mutation BatchDeleteSplitRouteCache($warehouseId: Long!, $areaIds: [Long!]) {
        batchDeleteSplitRouteCache(warehouseId: $warehouseId, areaIds: $areaIds)
    }
`;

export interface SplitRouteCacheDetailItem {
    areaId: number;
    areaName: string;
    data: string | null;
    savedAt: number | null;
}

export interface ListSplitRouteCacheResponse {
    listSplitRouteCache: SplitRouteCacheDetailItem[];
}

export interface ListSplitRouteCacheVariables {
    warehouseId: number;
    areaId?: number | null;
}

export interface BatchDeleteSplitRouteCacheResponse {
    batchDeleteSplitRouteCache: number;
}

export interface BatchDeleteSplitRouteCacheVariables {
    warehouseId: number;
    areaIds?: number[] | null;
}
